import { useNavigate, useParams } from "react-router-dom"
import { feedMemoColumns, useCreateFeedMemoAdmin, useGetFeedAdminByFeedId } from "../../model"
import { App, Button, Form, Input, Select, Spin, Table } from "antd"
import { InlineContent } from "../../../../../components/Shared"
import { useEffect, useState } from "react"
import dayjs from "dayjs"
import { useCreateOrUpdateFeedHiddenAdmin } from "../../../feedAndCommentClaimManage/detail/model"
import { feedCommentClaimDataList } from "../../../feedCommentManage/model"
import FeedManageDetailFeedCommentModal from "../commentModal"

const FeedManegeDetail = () => {
    const navigate = useNavigate()
    const id = Number(useParams().id)
    const [selectStatus, setSelectStatus] = useState<string>('null');
    const [selectReason, setSelectReason] = useState<string>('');
    const responseQuery = 'id nickName content createdDate feedHiddenId isHidden status reason feedCommentCnt imageUrlList feedMemoAdminResponseList { id feedId content createdDate memberName }';
    const { data, isPending, isError, isSuccess, refetch } = useGetFeedAdminByFeedId<IFeedAdminResponse>(id, responseQuery)
    const createOrUpdateFeedHiddenAdmin = useCreateOrUpdateFeedHiddenAdmin();
    const [menoContent, setMenoContent] = useState<string>('');
    const createFeedMemoAdmin = useCreateFeedMemoAdmin();
    const { message } = App.useApp()


    const onClickSave = () => {
        createOrUpdateFeedHiddenAdmin.mutate({
            feedId: id,
            status: selectStatus,
            reason: selectReason
        }, {
            onSuccess: () => {
                refetch()
                message.success('저장되었습니다.')
            }
        })
    }

    const handleCreateMemo = () => {
        createFeedMemoAdmin.mutate({ feedId: id, content: menoContent }, {
            onSuccess: () => {
                setMenoContent('');
                refetch()
                message.success('저장되었습니다.')
            }
        })
    }

    useEffect(() => {
        if (!data || !isSuccess) return;
        setSelectStatus(data.status ?? 'null')
        setSelectReason(data.reason ?? '')
    }, [isSuccess])

    if (isError) return <Spin size='large' />

    return <>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <InlineContent title='닉네임' content={data?.nickName} />
            <InlineContent title='작성일시' content={dayjs(data?.createdDate).format('YYYY.MM.DD HH:mm')} />
            <InlineContent title='내용' content={data?.content} />
            <InlineContent title='사진' content={data?.imageUrlList?.map((q, idx) => <img key={idx} src={q} width={60} height={60} alt="img" style={{ width: 'auto', height: '25vh', borderRadius: 4, marginRight: '12px' }} />)} />
            {data && <InlineContent title='처리 상태' content={<Select loading={createOrUpdateFeedHiddenAdmin.isPending} defaultValue={String(data.status)} onChange={q => setSelectStatus(q)}>
                <Select.Option value='null'>미처리</Select.Option>
                <Select.Option value='complete'>처리완료(노출유지)</Select.Option>
                <Select.Option value='hidden'>숨김처리</Select.Option>
            </Select>} />}
            {selectStatus === 'hidden' &&
                <InlineContent title="숨긴 사유" content={<div>
                    <Select defaultValue={data?.reason} value={selectReason} options={feedCommentClaimDataList} onChange={q => setSelectReason(q)} style={{ width: '300px' }} />
                </div>} />}

            <InlineContent title='댓글' content={<div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div>
                    {data?.feedCommentCnt ?? 0}개
                </div>
                <FeedManageDetailFeedCommentModal feedId={id} />
            </div>} />
        </div>

        <div style={{ marginTop: '24px', fontWeight: 700 }}>
            메모
        </div>
        <Form
            onFinish={handleCreateMemo}
        >
            <Form.Item name={'memo'} >
                <div style={{ display: 'flex', gap: '12px', marginTop: '12px' }}>
                    <Input.TextArea style={{ width: '30%' }} value={menoContent} onChange={q => setMenoContent(q.target.value)} />
                    <Button htmlType='submit'>메모 추가</Button>
                </div>
            </Form.Item>
        </Form>
        <Table dataSource={data?.feedMemoAdminResponseList?.sort((a, b) => dayjs(b.createdDate).diff(dayjs(a.createdDate)))} rowKey={'id'} columns={feedMemoColumns} style={{ marginTop: '24px' }} loading={isPending} />

        <div style={{ display: 'flex', gap: '8px', marginLeft: '20%', marginTop: '24px' }}>
            <Button onClick={() => { navigate(-1) }}>
                취소
            </Button>
            <Button type='primary' onClick={onClickSave}>저장</Button>
        </div>
    </>
}


export default FeedManegeDetail